
import { greekSearchFilter } from "@/helpers/data";
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  commonModule,
  appointmentsModule,
  actionTypesModule,
  itemsModule,
  companyModule,
} from "@/store/modules/store-accessor";
import { TimeUtil } from "@/helpers/TimeUtil";
import AssigneeMultiUserCombo from "@/components/Combobox/AssigneeMultiUserCombo.vue";
import _ from "lodash";
import { calcDuration, durationOptionByMinutes, getOptimalTextColor, primaryInstallationItemText } from "@/helpers/data";
import AppointmentCalendar from "@/components/Calendar/AppointmentCalendar.vue";
import EventOverlappingWarning from "@/components/Alerts/EventOverlappingWarning.vue";
import InstallationItemWarrantyIndicator from "@/components/InstallationItemWarrantyIndicator.vue";

@Component({
  components: {
    AssigneeMultiUserCombo,
    AppointmentCalendar,
    EventOverlappingWarning,
    InstallationItemWarrantyIndicator,
  },
})
export default class EditAppointmentModal extends Vue {
  @Prop()
  payload!: any;

  isEditingAppoinment = false;
  loadingInstallationPrimaryItems = true;

  greekSearchFilter = greekSearchFilter;

  menu3 = false;
  menu4 = false;

  payloadAppointmentModel = {} as any;
  primaryInstallationItemsCombo = [] as any;

  appointmentModel = {} as any;

  scheduledDateRule = [
    (val: any) => !!val || this.$i18n.t("scheduled_day_required"),
  ];

  userRule = [(val: any) => !!val || this.$i18n.t("user_required")];

  typeRule = [
    (val: any) => this.typeFound(val) || this.$i18n.t("action_required"),
  ];
  scheduledTimeRule = [
    (val: any) => !!val || this.$i18n.t("scheduled_time_required"),
  ];
  durationRule = [
    (val: any) =>
      (val || "")?.text?.length > 0 || this.$i18n.t("duration_required"),
  ];
  notesRule = [
    (val: any) => {
      if (val != null)
        return val.length <= 1000 || this.$i18n.t("notesLengthRule");
      else return true;
    },
  ];
  descriptionRule = [
    (val: any) => val?.length <= 80 || this.$i18n.t("jobDescriptionLengthRule"),
  ];

  textFound(duration: string) {
    const found = commonModule.durationCombo?.find((item: any) => {
      return item.text === duration;
    });
    return found == undefined ? false : true;
  }

  primaryItemText(item: Record<string, any>) {
    return primaryInstallationItemText(item);
  }

  durationFound(duration: string) {
    const found: any = commonModule.durationCombo?.find((item: any) => {
      return item.text === duration;
    });
    return found == undefined ? "" : found.dur;
  }

  get durationCombo() {
    return commonModule.durationCombo;
  }

  get actionsCombo() {
    return actionTypesModule.actionTypesCombo;
  }

  get assigneeIdCombo() {
    return commonModule.personnelCombo;
  }

  optimalTextColor(color: string) {
    return getOptimalTextColor(color);
  }

  setDurationFromActionType(actionType: any) {
    const duration = durationOptionByMinutes(this.durationCombo, actionType?.duration);
    if (duration) {
      this.appointmentModel.duration = duration;
    }
  }

  getAssignee(name: string) {
    const combo: any = commonModule.personnelCombo;
    const foundItem = combo.find((item: any) => item.name === name);
    if (foundItem) {
      return { name: foundItem.name, id: foundItem.id };
    } else {
      return "";
    }
  }

  itemName(obj: any) {
    const installationItemDescriptionIsEnabled = (companyModule.company?.preferences as any)?.installation_item_description;
    if(installationItemDescriptionIsEnabled) {
      obj = { ...obj, primary_items: `${obj.item_description ? obj.item_description + ' | ' : ''}${obj.primary_items}`}
    }
    this.primaryInstallationItemsCombo = this.installationPrimaryItems;
    const foundItem = this.primaryInstallationItemsCombo.find(
      (item: any) =>
        item.primary_items[0] == obj.primary_items && item.id === obj.id
    );
    if (foundItem) {
      return foundItem;
    } else {
      if (obj.id) {
        let item_hidden_id = (Math.random() + 1).toString(36).substring(7);
        this.primaryInstallationItemsCombo.push({
          ...obj,
          disabled: true,
          hidden_id: item_hidden_id,
        });
        return {
          ...obj,
          disabled: true,
          hidden_id: item_hidden_id,
        };
      } else {
        return { primary_items: "", id: 0 };
      }
    }
  }

  async hideModal() {
    commonModule.hideModal();
  }

  get editDisabled() {
    return _.isEqual(this.appointmentModel, this.payloadAppointmentModel);
  }

  /** Draft slot text aligned with calendar rows (assignee · type · place); payload keeps stable address/client. */
  get editCalendarSelectionLabel(): string {
    const m = this.appointmentModel;
    const appt = this.payload?.appointment;
    if (!m || !appt) {
      return "";
    }
    const assigneePart =
      Array.isArray(m.assignee_ids) && m.assignee_ids.length > 0
        ? m.assignee_ids
            .map((x: any) => (typeof x === "string" ? x : x?.name))
            .filter(Boolean)
            .join(", ")
        : m.assignee?.name || appt.assignee_id || "";
    const typePart = m.type_id?.text || appt.type_name || "";
    const street = (appt.address || "").toString().split(",")[0].trim();
    const area = (appt.area || "").toString().trim();
    let addrPart = street || area;
    if (!addrPart && appt.is_business && appt.entity_name && appt.client_name) {
      addrPart = `${appt.entity_name} (${appt.client_name})`;
    } else if (!addrPart && appt.client_name) {
      addrPart = appt.client_name;
    }
    return [assigneePart, typePart, addrPart].filter(Boolean).join(" · ");
  }

  async beforeMount() {
    await itemsModule.getInstallationPrimaryInventoryItems(
      this.payload.appointment.installation_id
    );
    await Promise.all([
      commonModule.getPersonnelCombo(),
      commonModule.getActionCombo(),
      commonModule.getDurationCombo(),
      actionTypesModule.getActionTypesCombo(),
    ]);
    this.loadingInstallationPrimaryItems = true;
    this.loadingInstallationPrimaryItems = false;

    const foundActionType = actionTypesModule.actionTypesCombo.find(
      (item: any) => item.id === this.payload.appointment.action_type_id
    );
    this.payloadAppointmentModel.type_id = {
      text: this.payload.appointment.type_name,
      color: foundActionType?.color || (this.payload.appointment as any).type_color || "",
      cost: foundActionType?.cost ?? 0,
      id: this.payload.appointment.action_type_id,
    };
    this.payloadAppointmentModel.assignee = this.getAssignee(
      this.payload.appointment.assignee_id
    );
    this.payloadAppointmentModel.assignee_id =
      this.payloadAppointmentModel.assignee?.id;
    this.payloadAppointmentModel.assignee_ids =
      this.payload.appointment.assignee_ids;
    this.payloadAppointmentModel.assignees = this.payload.appointment.assignees;
    this.payloadAppointmentModel.appointment_status_id = 2;
    this.payloadAppointmentModel.scheduled_start = this.formatDate(
      this.payload.appointment.scheduled_start
    );
    this.payloadAppointmentModel.scheduled_start_time = this.formatTime(
      this.payload.appointment.scheduled_start
    );
    this.payloadAppointmentModel.duration = {
      dur: this.durationFound(
        calcDuration(
          this.payload.appointment.scheduled_start,
          this.payload.appointment.scheduled_end
        )
      ),
      text: this.textFound(
        calcDuration(
          this.payload.appointment.scheduled_start,
          this.payload.appointment.scheduled_end
        )
      )
        ? calcDuration(
            this.payload.appointment.scheduled_start,
            this.payload.appointment.scheduled_end
          )
        : "",
    };
    this.payloadAppointmentModel.appointment_notes =
      this.payload.appointment.notes || "";
    this.payloadAppointmentModel.installation_id =
      this.payload.appointment.installation_id;
    this.payloadAppointmentModel.id = this.payload.appointment.id;
    this.payloadAppointmentModel.job_id = this.payload.appointment.job_id || "";
    this.payloadAppointmentModel.installation_item_id = this.itemName({
      primary_items: this.payload.appointment.job_item,
      id: this.payload.appointment.installation_item_id,
      item_type_text: this.payload.appointment.item_type_text,
      item_make: this.payload.appointment.item_make,
      item_model: this.payload.appointment.item_model,
      item_serial_no: this.payload.appointment.item_serial_no,
      item_description: this.payload.appointment.item_description,
    });
    this.payloadAppointmentModel.job_description = this.payload.appointment.job_description || "";
    this.payloadAppointmentModel.send_client_email = this.clientHasEmail ? this.isSendClientAppointmentEmailEnabled : false;

    this.appointmentModel = _.cloneDeep(this.payloadAppointmentModel);
  }

  async mounted() {
    commonModule.initSnackbar({});
  }

  async updateAssignee(assignees: any) {
    this.appointmentModel.assignee_id = assignees?.[0]?.id || null;
    this.appointmentModel.assignee = assignees?.[0];
    this.appointmentModel.assignee_ids = assignees;

    await Promise.all([
      commonModule.getPersonnelCombo(),
      commonModule.getActionCombo(),
      commonModule.getDurationCombo(),
      actionTypesModule.getActionTypesCombo(),
    ]);

    this.loadingInstallationPrimaryItems = true;
    this.loadingInstallationPrimaryItems = false;
  }

  formatDate(date: Date): string {
    return TimeUtil.formatDateOnly(date);
  }

  formatTime(date: Date): string {
    return TimeUtil.formatTimeOnly(date);
  }

  typeFound(type: any) {
    if (type) {
      const found = this.actionsCombo?.find((item: any) => {
        return item["text"] === type.text;
      });
      return found == undefined ? false : true;
    }
    return false;
  }

  get installationPrimaryItems() {
    return itemsModule.installationPrimaryItems;
  }

  get isLoadingInstallationPrimaryItems() {
    return this.loadingInstallationPrimaryItems;
  }

  get disablePrimaryItems() {
    return (
      this.loadingInstallationPrimaryItems ||
      this.installationPrimaryItems.length === 0
    );
  }

  async doEdit() {
    if (!(this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      return;
    }

    this.isEditingAppoinment = true;
    appointmentsModule.unsetCalendarAppointments();
    try {
      await appointmentsModule.editAppointment(this.appointmentModel);
      if(this.$route.name === "Calendar") {
	await appointmentsModule.getCalendarAppointmentsAction(appointmentsModule.filters);
      }
      this.hideModal();
    } catch {
      await appointmentsModule.getCalendarAppointmentsAction(appointmentsModule.filters);
    } finally {
      this.isEditingAppoinment = false;
    }
  }

  get jobDescriptionIsEnabled() {
    return (companyModule.company?.preferences as any)?.job_description;
  }

  get hasClientSelected() {
    return this.payload.appointment && this.payload.appointment.client_email !== undefined;
  }

  get clientHasEmail() {
    if (!this.hasClientSelected) return false;
    const email = this.payload.appointment.client_email;
    return email !== undefined && email !== null && email !== '';
  }

  get isSendClientAppointmentEmailEnabled() {
    return (companyModule.company?.preferences as Record<string, any>)?.send_client_appointment_email;
  }

  get disableSendEmailToClient() {
    return !(companyModule.company?.preferences as Record<string, any>)?.send_client_appointment_email || !this.hasClientSelected || !this.clientHasEmail;
  }

}
